import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-built-drawing',
  templateUrl: './built-drawing.component.html',
  styleUrls: ['./built-drawing.component.css']
})
export class BuiltDrawingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/planning/built-drawing/built-drawing.component.ts